import { language as lan_shippingCostTable } from "./shipping-cost-table";
let language = {
    SHIPPING_COST_TITLE: "运费计算器",
    SHIPPING_COUNTRY_TITLE: "选择配送国家或地区 :",
    SHIPPING_COUNTRY_ERROR: "没有结果匹配",
    SHIPPING_DELIVERY: "没有结果匹配",
    SHIPPING_RESET: "重置",
    SHIPPING_ESTIMATED: "预计运费:",
    SHIPPING_TABLE_EXPORT: "导出",
    SHIPPING_content_1: "请确认运费计算表上的产品是否与您的选择相符，以避免任何潜在的误解。",
    SHIPPING_content_2: "交货时间是估计的，可能会根据处理的订单数量而有所不同。 准确的费用和交货时间将显示在结帐处供您查看。",
    ...lan_shippingCostTable
}

export { language }